import styled, { keyframes } from 'styled-components';
import colors from 'styles/colors';

/** Painel lateral "Gerar arquivo do licitante" da Análise do Edital (Gestão IA). */

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  /* acima do modal do card da Gestão IA (3000000001) */
  z-index: 3000000002;
  background: rgba(33, 53, 74, 0.35);
  display: flex;
  justify-content: flex-end;
`;

export const Panel = styled.div`
  width: 560px;
  max-width: 94vw;
  height: 100%;
  background: ${colors.$white};
  display: flex;
  flex-direction: column;
  animation: ${slideIn} 0.2s ease;

  .drawer-content {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px;
  }

  .drawer-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
  }

  .drawer-title {
    margin: 0;
    color: ${colors.$gray900};
    font-size: 15px;
    font-weight: 600;
  }

  .drawer-close {
    display: flex;
    align-items: center;
    padding: 0;
    border: none;
    background: none;
    color: ${colors.$gray700};
    cursor: pointer;

    .material-icons {
      font-size: 20px;
    }
  }

  .report-option {
    margin-top: 16px;
    color: ${colors.$gray900};
    font-size: 14px;

    .custom-control-label {
      cursor: pointer;
    }
  }

  .report-option-count {
    color: ${colors.$gray600};
  }

  .questions-toggle {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin: 8px 0 0 24px;
    padding: 0;
    border: none;
    background: none;
    color: ${colors.$primary};
    font-size: 14px;
    cursor: pointer;

    .material-icons {
      font-size: 18px;
    }
  }

  .questions-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 12px 0 0 24px;
  }

  .question-card {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border: 1px solid ${colors.$gray300};
    border-radius: 8px;
  }

  .question-text {
    flex: 1;
    min-width: 0;
    margin: 0;
    color: ${colors.$gray900};
    font-size: 14px;
    line-height: 1.35;
    word-break: break-word;

    &.is-clamped {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .question-expand {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    padding: 0;
    border: 1px solid ${colors.$gray300};
    border-radius: 6px;
    background: ${colors.$white};
    color: ${colors.$gray700};
    cursor: pointer;

    .material-icons {
      font-size: 18px;
    }
  }

  .questions-empty {
    margin: 12px 0 0 24px;
    color: ${colors.$gray600};
    font-size: 14px;
  }

  .drawer-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 12px;
    padding: 16px;
    border-top: 1px solid ${colors.$gray300};
  }

  .drawer-error {
    flex: 1;
    margin: 0;
    color: ${colors.$danger};
    font-size: 13px;
  }

  .drawer-generate {
    height: 38px;
    padding: 8px 24px;
    background: ${colors.$primary};
    border: 1px solid ${colors.$primary};
    border-radius: 6px;
    color: ${colors.$white};
    font-size: 15px;
    cursor: pointer;

    &:disabled {
      opacity: 0.65;
      cursor: default;
    }
  }
`;
